// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XRow_XComponent__-LFxE, .XRow_XRow__8U8D- {
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  margin-bottom: var(--margin-bottom);
}

.XRow_XRow__8U8D- {
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  flex-shrink: 0;
  display: flex;
  flex: content;
  flex-grow: 1;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/X/components/commons/XComponent.module.scss","webpack://./src/X/components/layouts/XRow.module.scss","webpack://./src/X/styles/common.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,iCAAA;EACA,6BAAA;EACA,mCAAA;ACCJ;;AADA;ECDI,kBAAA;EACA,yBAAA;EACA,mBAAA;EAKA,cAAA;EDFA,aAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAKJ","sourcesContent":[".XComponent {\r\n    margin-left: var(--margin-left);\r\n    margin-right: var(--margin-right);\r\n    margin-top: var(--margin-top);\r\n    margin-bottom: var(--margin-bottom);\r\n}","@use \"../../styles/common\";\n@use \"../../styles/themes\";\n@use '../commons/XComponent.module.scss';\n\n.XRow {\n    @extend .XComponent;\n    @include common.nodebug;\n    @include common.noshrink;\n    display: flex;\n    flex: content;\n    flex-grow: 1;\n    flex-direction: row;\n}","\n@mixin nodebug\n{\n    outline-width: 0px;\n    outline-color: chartreuse;\n    outline-style: none;\n}\n\n@mixin noshrink\n{\n    flex-shrink: 0;\n}\n\n@mixin noselect {\n    -webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n@mixin nomouse {\n    pointer-events: none;\n}\n\n@mixin border-box {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XComponent": `XRow_XComponent__-LFxE`,
	"XRow": `XRow_XRow__8U8D-`
};
export default ___CSS_LOADER_EXPORT___;
